const API_SERVICES = ['MYCAR_COMMON_COMMENTS_API', 'AB_TEST'];
const WEB_SERVICES = ['ABOUT', 'AB_TEST_LOG', 'ADS_AND_POINTS', 'APP_GATEWAY', 'CAMPAIGN', 'CARD', 'CARD_SEARCH', 'CART', 'CPM_POINT_GAMBLE', 'EASY_APPLY', 'EVENT', 'FRIENDS', 'GFD', 'GIFT', 'HANABANK', 'HELP', 'INFLOW', 'INSURANCE', 'INVOICE', 'KEYPAD', 'LAND', 'L_PAY', 'MYCAR_COMMON_COMMENTS_DOMAIN', 'MYMONEY', 'MYMONEY_EVENT', 'MY_CAR', 'MY_GIFT', 'MY_MONEY', 'M_SHOPPING', 'M_SHOPPING_HOME', 'M_SHOPPING_MY_BRANCH', 'M_SHOPPING_SUBSCRIPTIONS', 'PC_SHOPPING_SUBSCRIPTIONS', 'M_HAPPYBEAN_SUBSCRIPTION', 'PC_HAPPYBEAN_SUBSCRIPTION', 'NAVER', 'NEW_PAY', 'NID', 'ORDER', 'PAY', 'PAY_APP', 'PAY_SEND', 'PC_CAMPAIGN', 'PC_ORDER', 'PC_PAY', 'PLACE', 'POINT_GIFT', 'REWARD_PARTNERSHIP', 'SDK', 'SHOPPING', 'STANDBY', 'STATIC', 'TALKTALK', 'TALK_TO', 'TRACE', 'FE_CDN_ORIGIN', 'AD_PLATFORM'];
const AVAILABLE_SERVICES = [...API_SERVICES, ...WEB_SERVICES];
const Phase = {
  alpha: 'alpha',
  dev: 'dev',
  local: 'local',
  stage: 'stage',
  real: 'real',
  test: 'test'
};

export { API_SERVICES, AVAILABLE_SERVICES, Phase, WEB_SERVICES };
